import { Component, inject, input, signal } from '@angular/core';
import { BuildingFilterDto, InspectionFilterDto, InspectionItemDto, InspectionService } from '@artemis-software/wr-api';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { currentTenant } from '@/utils/admin-utils';
import StatusEnum = InspectionItemDto.StatusEnum;
import TenantTypeEnum = BuildingFilterDto.TenantTypeEnum;

@Component({
  standalone: false,
  selector: 'wr-building-inspection-overview',
  templateUrl: './building-inspection-overview.component.html',
  styleUrl: './building-inspection-overview.component.scss'
})
export class BuildingInspectionOverviewComponent {

  readonly inspectionService = inject(InspectionService);
  readonly router = inject(Router);
  readonly formBuilder = inject(FormBuilder);
  protected readonly TenantTypeEnum = TenantTypeEnum;

  readonly buildingId = input.required<string | null>();

  readonly loadInspections = (filter: InspectionFilterDto) => this.inspectionService.findAll(this.prepareInspectionFilter(filter));
  readonly getInspectionCount = (filter: InspectionFilterDto) => this.inspectionService.getCount(this.prepareInspectionFilter(filter));

  inspectionListFilterForm!: FormGroup;

  tenant = currentTenant();

  constructor() {

    this.inspectionListFilterForm = this.formBuilder.group({
      text: this.formBuilder.control(''),
      tenantId: this.formBuilder.control(undefined),
      continuationNumber: this.formBuilder.control(undefined),
      assignedInternalTenantId: this.formBuilder.control<string | null>(null),
    });
  }

  readonly prepareInspectionFilter = (filter: InspectionFilterDto) => {
    const buildingId = this.buildingId();
    if (buildingId) {
      filter.buildingId = buildingId;
    }

    const assignedInternalTenantId = this.inspectionListFilterForm.get('assignedInternalTenantId')?.value;
    if (assignedInternalTenantId) {
      filter.internalTenantId = assignedInternalTenantId;
    }
    if(this.tenant()?.type === TenantTypeEnum.External) {
      filter.status = StatusEnum.Sent;
    }
    return filter;
  };


  navigateToInspection(entry: InspectionItemDto): void {
    this.router.navigate(['inspection', entry.id]);
  }

  protected readonly signal = signal;
}
